<template lang="pug">
div#bin_card_main.bin-card_main
  div#bin_card_main_wrapper(:class="wrapperBinCardMain")
    .sofia-line(:class="loadingAnimation" v-if="notFullView")
    div(:class="fullViewClassContent")
      forms-messages-list-vue(
        id="errors"
        :messages="errors"
        :single_message="true"
        :notification_message="true"
      )
      div(v-if="!hasErrors" :class='sortRowClass')
        div(:class="titleSectionClass" v-if='showCardDescription')
          div(:class="fullHeaderClass" v-if="this.bin_card.match")
            p#bin_info_title(:class="fullTitleClass") {{ bin_card.match }}
            p(:class="domainClass()" v-if="validateDomain")#bin_info_domain {{ bin_card.domain }}
          .sofia-line.mb-4(v-if="!notFullView")
          .col-3.bin-btn.pl-0.d-flex.justify-content-end.pr-2(v-if="notFullView")
            slot(name="bin-buttons")
        div(:class="descriptionSectionClass" v-if='showCardDescription')
          bin-card-description-vue(
            ref="bin_card_info",
            :description="bin_card.descripcion",
            @bin_card_info_mounted="addModalListeners",
            :fullView="full_view",
            :descriptionHeight="descriptionHeight"
          )
        div(v-else)
          .box_hub.description#loading-documents(
            v-for="loadingDescriptionBox in loadingDescriptionBoxes"
          )
        div(:class="relatedDocumentsSectionClass" v-if='showTypeDocuments')
          bin-card-documents-vue(
            v-if="showRelatedDocuments",
            :related_documents='bin_card.docs',
            @relatedDocumentData='showDocument',
            :fullView="full_view"
          )
        div(v-else)
          .box_hub.related_documents.mb-2#loading-related-documents(
            v-for="loadingRelatedBox in loadingRelatedBoxes"
          )
        div.col-12.p-0(v-if='showRelatedCardsList')
          bin-card-related-list-vue(
            v-if="showRelatedCards",
            :relatedCards='bin_card.specialize',
            :fullView="full_view"
          )
          div.col-12.d-flex.justify-content-end
            a.mt-4#bin-feedback(:href="typeFormFeedbackLink") {{ t('components.bin_card.feedback_form') }}
        div(v-else)
          .box_hub.related_cards.mb-2#loading-related-cards
    div#bin-card-footer.bin-card-footer(:class="sizeCardIaClass")
      img(src="../../../assets/images/bin-card/icoAi.png", alt="icoAlert", class="mr-2")
      p#bin_card_footer_text_ia.m-0 {{ t('components.bin_card.ia_label') }}
  <modal-quick-view-vue :bus="bus" :copy-buttons-visible="false" :search-type='relatedDocumentType'/>
</template>

<script>
import Vue from 'vue'
import bin_card_mixin from 'common/mixins/bin_card_mixin'
import mixins from 'common/mixins'
import { trackEvent } from 'common/metrics'

export default {
  name: 'bin-card-vue',
  mixins: [bin_card_mixin.requests, mixins.translate],
  data: () => ({
    bus: new Vue(),
    showDescription: true,
    relatedDocumentType: '',
    errors: {},
    loadingDescriptionBoxes: 3,
    loadingRelatedBoxes: 5,
    loadDescription: false,
    loadRelatedDocuments: false,
    loadRelatedCardsList: false,
    descriptionHeight: 0,
  }),
  props: {
    bin_card: { type: Object, default: {} },
    full_view: { type: Boolean, default: false },
  },
  components: {
    'bin-card-description-vue': () =>
      import(
        /* webpackChunkName: "[request]" */ 'components/bin_card/BINCardDescription'
      ),
    'bin-card-documents-vue': () =>
      import(
        /* webpackChunkName: "[request]" */ 'components/bin_card/BINCardDocuments'
      ),
    'bin-card-related-list-vue': () =>
      import(
        /* webpackChunkName: "[request]" */ 'components/bin_card/BINCardRelatedList'
      ),
    'forms-messages-list-vue': () =>
      import(
        /* webpackChunkName: "[request]" */ 'components/forms/MessagesList'
    )
  },
  methods: {
    showDocument(id, document_type) {
      this.relatedDocumentType = document_type
      this.bus.$emit('document_show', id, document_type)
    },
    addModalListeners(){
      this.$refs.bin_card_info.$refs.description.addEventListener('click', (event) => {
        event.preventDefault()
        let docid = event.target.dataset.docid
        if(docid && docid != 'bin_info_description')
          this.showDocument(docid, '')
      })
    },
    domainClass() {
      if(this.bin_card.domain && this.bin_card.domain !== undefined){
        return this.full_view ? `bin-header__domain-full-${this.bin_card.domain.toLowerCase()}` :
          `bin-header__domain-${this.bin_card.domain.toLowerCase()}`
      }
    },
    async loadComponentsSequentially(index = 0) {
      const componentsToLoad = [
        { name: 'loadDescription', delay: 1200},
        { name: 'loadRelatedDocuments', delay: 1000 },
        { name: 'loadRelatedCardsList', delay: 1000 }
      ]

      for (let i = index ; i < componentsToLoad.length ; i++) {
        const { name, delay } = componentsToLoad[i]
        await new Promise((resolve) => setTimeout(resolve, delay))
        this[name] = true
      }
    },
  },
  computed: {
    showRelatedDocuments() {
      return this.bin_card.docs ? Object.keys(this.bin_card.docs).length > 0 : false
    },
    showRelatedCards() {
      if (this.bin_card.specialize) {
        return this.bin_card.specialize.length > 0
      }
      return false
    },
    fullViewClassContent(){
      return this.full_view ? 'container-fluid' : 'bin-card-box'
    },
    fullHeaderClass() {
      return this.full_view ? 'bin-header-full' : 'col-9 bin-header'
    },
    fullTitleClass() {
      return this.full_view ? 'bin-header__title-full' : 'bin-header__title'
    },
    loadingAnimation() {
      return this.loadRelatedCardsList ? '' : 'animate'
    },
    validateDomain() {
      return this.bin_card.domain !== ''
    },
    notFullView() {
      return !this.full_view
    },
    hasErrors() {
       return Object.keys(this.errors).length > 0
    },
    sortRowClass() {
      return this.full_view ? 'row pr-4' : ''
    },
    sortRowClassInternal() {
      return this.full_view ? 'row px-4' : ''
    },
    titleSectionClass() {
      return this.full_view ? 'col-12' : 'row'
    },
    descriptionSectionClass() {
      return this.full_view ? 'col-12 col-lg-8 pl-1' : ''
    },
    relatedDocumentsSectionClass() {
      return this.full_view ? 'col-12 col-lg-4' : ''
    },
    showCardDescription() {
      return this.full_view ? true : this.loadDescription
    },
    showTypeDocuments() {
      return this.full_view ? true : this.loadRelatedDocuments
    },
    showRelatedCardsList() {
      return this.full_view ? true : this.loadRelatedCardsList
    },
    sizeCardIaClass(){
      return this.full_view ? 'bin-card-footer-expand' : 'bin-card-footer-collapsed'
    },
    wrapperBinCardMain(){
      return this.full_view ? 'bin-card-expand' : 'bin-card-collapsed'
    }
  },
  watch: {
    bin_card() {
      if(!this.full_view){
        this.loadDescription = false
        this.loadRelatedDocuments = false
        this.loadRelatedCardsList = false
        this.loadComponentsSequentially()
      }
      if(this.bin_card.origin_from) { trackEvent('BIN', 'Tarjeta visualizada', this.bin_card.origin_from) }
    }
  },
  mounted(){
    if(this.bin_card.error){
      this.$set(this.errors, this.bin_card.error, I18n.t('servicio_caido', {code_error: this.bin_card.error}))
    }

    setTimeout(() => {
      if (this.$refs.bin_card_documents) {
      const documentComponentHeight = this.$refs.bin_card_documents.$el.offsetHeight
      this.descriptionHeight = documentComponentHeight
    }}, 100)

    if(this.bin_card.origin_from) { trackEvent('BIN', 'Tarjeta visualizada', this.bin_card.origin_from) }
  },
  beforeUnmount() {
    this.$refs.bin_card_info.$refs.description.removeEventListener('click')
  }
}
</script>
